/**
 *
 * @module entry
 * @desc {SDK.Services.CustomerService} entry point.
 *
 */

import CustomerServiceClient from './customerServiceClient';
import CustomerServiceClientConfiguration from './customerServiceClientConfiguration';
import CustomerServiceClientEndpoint from './customerServiceClientEndpoint';

/**
 *
 * @typedef SDK.Services.CustomerService
 * @type {Object}
 *
 * @property {CustomerServiceClient} CustomerServiceClient
 * @property {CustomerServiceClientConfiguration} CustomerServiceClientConfiguration
 * @property {CustomerServiceClientEndpoint} CustomerServiceClientEndpoint
 *
 */

/**
 *
 * @type {SDK.Services.CustomerService}
 *
 */
export default {

    CustomerServiceClient,
    CustomerServiceClientConfiguration,
    CustomerServiceClientEndpoint

};



// WEBPACK FOOTER //
// ./src/services/customerService/entry.js